import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CasillaActualService } from 'src/app/services/casilla-actual.service';
import * as CryptoJS from 'crypto-js';
import { ToastService } from 'src/app/shared/services/toast.service';
import { UsuariosService } from 'src/app/services/usuarios.service';

import { AppStore } from 'src/app/core/store/app.store';

@Component({
  selector: 'app-cambio-clave',
  templateUrl: './cambio-clave.component.html',
  styleUrls: ['./cambio-clave.component.scss']
})
export class CambioClaveComponent implements OnInit {

  readonly state$ = this.appStore.state$;

  usuario: string
  sessionUser = this.appStore.state.session.user;

  datosRegistro: {
    clave: string,
    claveSeg: string,
    claveActual: string
  } = {
    clave: "",
    claveSeg: "",
    claveActual: ""
  }

  //visor de contraseñas
  isTypeP1bol = false; 
  isTypeP2bol = false; 
  isTypeP3bol = false;

  //cambie el type de la contraseña
  isTypeP1 = null;
  isTypeP2 = null;
  isTypeP3 = null;
  
  constructor(
    private appStore: AppStore,
    private router: Router,
    private route: ActivatedRoute,
    private casillaActual: CasillaActualService,
    private toast: ToastService,
    private usuariosService: UsuariosService,
  ) { }

  ngOnInit() {
    if (this.appStore.sessionAction.esSesionValida()) 
    {

      this.appStore.sessionAction.restablecerSesionDeLocalStorage();
      this.sessionUser = this.appStore.state.session.user;
      this.usuario = this.sessionUser.Name;
      //this.router.navigate(['/dashboard/']);
    }
    else 
    {
      let token = this.route.snapshot.queryParamMap.get('token');
      //console.log(token);
      if(token) {
        this.casillaActual.setSesion(token);
        
        this.router.navigate(['/dashboard/']);
      }
      else {
        this.router.navigate(['/login/']);
        //location.href = "http://localhost:5000/dashboard"; //environment.loginUrl + window.location.origin;
      }
    }

    this.isTypeP1 = "password";
    this.isTypeP2 = "password";
    this.isTypeP3 = "password";
  }

  encriptarClave = (dato: string): string => {
    return CryptoJS.MD5(dato).toString();
  };

  validarContraseña = (clave) => {
    let hasNumber = /\d/.test(clave);
    let hasUpper = /[A-Z]/.test(clave);
    let hasLower = /[a-z]/.test(clave);
    let hasSymbol = /[$@$!%*?&#.]/.test(clave);
    // console.log('Num, Upp, Low', hasNumber, hasUpper, hasLower);
    const valid = hasNumber && hasUpper && hasLower && hasSymbol;
    if (!valid) {
        // return what´s not valid
        return { strong: true };
    }
    return false;
  }

  handleCerrar = () => {
    this.router.navigate(['/dashboard/']);
    //console.log(this.selectedTipoRegistro);
  }

  handleVisorP = (type) => {
    switch (type) {
      case 1: this.isTypeP1bol = !this.isTypeP1bol;
              if(this.isTypeP1bol)
              {
                this.isTypeP1 = "text";
              }
              else
              {
                this.isTypeP1 = "password";
              }
              break;
        case 2: this.isTypeP2bol = !this.isTypeP2bol;
              if(this.isTypeP2bol)
              {
                this.isTypeP2 = "text";
              }
              else
              {
                this.isTypeP2 = "password";
              }
              break;
        case 3: this.isTypeP3bol = !this.isTypeP3bol;
              if(this.isTypeP3bol)
              {
                this.isTypeP3 = "text";
              }
              else
              {
                this.isTypeP3 = "password";
              }
              break;
    }
  }

  finalizar = () => {
    if(this.datosRegistro.claveActual == "")
    {
      this.toast.error("Por favor ingresa contraseña actual");
    }
    else if(this.datosRegistro.clave == "")
    {
      this.toast.error("Por favor ingresa nueva contraseña");
    }
    else if(this.datosRegistro.clave == "")
    {
      this.toast.error("Por favor repita la contraseña");
    }
    else if(this.datosRegistro.clave != this.datosRegistro.claveSeg)
    {
      this.toast.error("Por favor ingresa la misma contraseña");
    }
    else if(this.validarContraseña(this.datosRegistro.clave))
    {
      this.toast.error("Contraseña invalida");
    }
    else{
      
      this.cambioClave();
    }
  }

  cambioClave = () =>  {
    this.usuariosService.cambioClave(this.sessionUser.Id,2,this.encriptarClave(this.datosRegistro.claveActual),this.encriptarClave(this.datosRegistro.clave)).subscribe((response) => {
      if(response.rptTipo == 1){
        var tipMensaje = "";
        if(this.sessionUser.TPais == 1){
          if(this.sessionUser.TDoc == '8'){
            tipMensaje = "RUC";
          }
          else{
            tipMensaje = "DNI";
          }
        }
        else{
          tipMensaje = "Usuario";
        }
        //var mensaje = "<div align=center style='border: 1px solid #000000; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:black;'><span style='color:white;' >ACCESO AL PORTAL DEL ADMINISTRADO DE PROVÍAS NACIONAL</span></div><div> <span>Estimados : </span><b>"+this.datosRegistro.razonSocial+" </b></br><span>Su registro fue generado de forma satisfactoria al <b>PORTAL DE SERVICIOS DE PROVÍAS NACIONAL</b> ahora podrá realizar sus trámites en línea</span></div><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'><span style='color:black;' ><b>SUS CREDENCIALES</b></span><div style='overflow:hidden;'><div style=' float: left;width: 50%;'> <div align=center style='border: 1px solid #82E0AA; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#ABEBC6;'> <span style='color:black;' ><b>"+ tipMensaje +": </b></span></br><span style='color:black;' ><b>"+this.datosRegistro.nroDocumento+"</b></span></div></div><div style='float:left;width: 50%;'> <div align=center style=' border: 1px solid #82E0AA; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#ABEBC6;'> <span style='color:black;' ><b>Contraseña: </b></span></br><span style='color:black;' ><b>"+this.datosRegistro.clave+"</b></span></div></div><span style='color:black;' ><b>ACCEDA AL PORTAL</b></span></br><span style='color:black;' ><a href='http://www.pvn.gob.pe'>www.pvn.gob.pe</a></span></div></div></br><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'> <span style='color:red;' ><b>IMPORTANTE</b></span></br> <span style='color:black;' ><b>El usuario y contraseña es personal e intransferible y el uso del mismo será bajo su responsabilidad</b></span> </div> </br><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'> <span style='color:red;' ><b>CONTACTENOS</b></span><ul style='list-style: none '> <li>Central Telefónica 615-7800</li></ul></div>";
        var mensaje = "<div align=center style='border: 1px solid #000000; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:black;'><span style='color:white;' >ACCESO AL PORTAL DEL ADMINISTRADO DE PROVÍAS NACIONAL</span></div><div><span>Estimados : </span><b>"+this.sessionUser.Name+"</b></div><div><span>Su registro fue generado de forma satisfactoria al <b>PORTAL DE SERVICIOS DE PROVÍAS NACIONAL</b> ahora podrá realizar sus trámites en línea</span></div><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'><span style='color:black;' ><b>SUS CREDENCIALES</b></span><div style='overflow:hidden;'><div style=' float: left;width: 50%;'><div align=center style='border: 1px solid #82E0AA; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#ABEBC6;'><div><span style='color:black;' ><b>"+ tipMensaje +"</b></span></div><div><span style='color:black;' ><b>"+this.sessionUser.NDoc+"</b></span></div></div></div><div style='float:left;width: 50%;'><div align=center style=' border: 1px solid #82E0AA; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#ABEBC6;'><div><span style='color:black;' ><b>Contraseña</b></span></div><div><span style='color:black;' ><b>"+this.datosRegistro.clave+"</b></span></div></div></div><div><span style='color:black;' ><b>ACCEDA AL PORTAL</b></span></div><div><span style='color:black;' ><a href='http://www.pvn.gob.pe'>www.pvn.gob.pe</a></span></div></div></div></br><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'><div><span style='color:red;' ><b>IMPORTANTE</b></span></br></div><div><span style='color:black;' ><b>El usuario y contraseña es personal e intransferible y el uso del mismo sera bajo su responsabilidad</b></span></div></div></br><div align=center style='border: 1px solid #85C1E9; -moz-border-radius: 9px; -webkit-border-radius:9px; padding: 10px;background-color:#AED6F1;'><span style='color:red;' ><b>CONTACTENOS</b></span><ul style='list-style: none '><li>Central Telefónica 615-7800</li></ul></div>";

        this.enviarEmailCodigo(this.sessionUser.email, "Cambio Clave Usuario PROVÍAS",mensaje,true);
        this.toast.error("Se realizo el cambio de clave correctamente");
        this.router.navigate(['/dashboard/']);
      }
    });
  }

  enviarEmailCodigo = (login, prueba, cuerpo, flag) => {
    this.usuariosService.enviarEmailDatosUsuario(login, prueba,cuerpo, flag).subscribe(
          (data) => {
            console.log(data) 
          },
        (error) => {
            console.log(error)
        }
    );
  };
}
